<ng-container [formGroup]="membershipDetailForm">
  <div class="input-group">
    <mat-form-field
      [color]="'accent'"
      [appearance]="matFormFieldAppearance"
      [hideRequiredMarker]="true">
      <mat-label>
        <ng-container *ngIf="isEmailForm; else defaultLabel">
          {{ loyaltyProgram.shortName }} account
        </ng-container>

        <ng-template #defaultLabel>
          {{
            'transfer_v2.checkout.label.membership_number'
              | translate
                : {
                    loyaltyProgramShortName: loyaltyProgram.shortName
                  }
          }}
        </ng-template>
      </mat-label>
      <input
        class="link-account-membership-number"
        matInput
        type="text"
        formControlName="membershipNumber" />
      <mat-hint
        class="validating-membership-number"
        *ngIf="membershipNumberValidationPending">
        {{ 'transfer_v2.checkout.hint.validating' | translate }}
      </mat-hint>
      <mat-error
        class="invalid-membership-number"
        *ngIf="isMembershipNumberInvalid"
        [attr.aria-live]="'polite'">
        <ng-container *ngIf="isEmailForm; else defaultInvalidError">
          Email address is invalid.
        </ng-container>

        <ng-template #defaultInvalidError>
          {{
            'transfer_v2.checkout.error.invalid_membership_number' | translate
          }}
        </ng-template>
      </mat-error>
      <mat-error
        class="required-membership-number"
        *ngIf="isMembershipNumberEmpty"
        [attr.aria-live]="'polite'">
        <ng-container *ngIf="isEmailForm; else defaultRequiredError">
          Please enter a valid email address.
        </ng-container>

        <ng-template #defaultRequiredError>
          {{
            'transfer_v2.checkout.error.required_membership_number' | translate
          }}
        </ng-template>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-group">
    <mat-form-field [color]="'accent'" [appearance]="matFormFieldAppearance">
      <mat-label>{{
        'transfer_v2.checkout.label.first_name' | translate
      }}</mat-label>
      <input
        class="link-account-first-name"
        matInput
        type="text"
        formControlName="firstName" />
      <mat-error class="required-first-name" *ngIf="isFirstNameEmpty">
        {{ 'transfer_v2.checkout.error.required_first_name' | translate }}
      </mat-error>
      <mat-error class="invalid-first-name" *ngIf="firstNameIsInvalid">
        {{ 'transfer_v2.checkout.error.invalid_first_name' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="input-group">
    <mat-form-field [color]="'accent'" [appearance]="matFormFieldAppearance">
      <mat-label>{{
        'transfer_v2.checkout.label.last_name' | translate
      }}</mat-label>
      <input
        class="link-account-last-name"
        matInput
        type="text"
        formControlName="lastName" />
      <mat-error class="required-last-name" *ngIf="isLastNameEmpty">
        {{ 'transfer_v2.checkout.error.required_last_name' | translate }}
      </mat-error>
      <mat-error class="invalid-last-name" *ngIf="lastNameIsInvalid">
        {{ 'transfer_v2.checkout.error.invalid_last_name' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</ng-container>
